import { getGlobalConfig } from '@/utils/globalConfig'

/**
 * Get list of supported area codes with global config
 * return default list if not available on global config
 *
 * @param currentLanguageCode
 * @return {[{isoCode: string, countryCode: string, countryName: string, urlImage: *}]} List of area codes and flags
 */
export const getSupportedAreaCodes = (currentLanguageCode = 'en') => {
  const defaultValues = [
    {
      urlImage: require('@static/img/flag-sg.svg'),
      isoCode: 'SG',
      countryCode: '+65',
      countryName: 'Singapore'
    },
    {
      urlImage: require('@static/img/flag-hk.svg'),
      isoCode: 'HK',
      countryCode: '+852',
      countryName: 'Hong Kong'
    },
    {
      urlImage: require('@static/img/flag-macau.svg'),
      isoCode: 'MO',
      countryCode: '+853',
      countryName: 'Macau'
    },
    {
      urlImage: require('@static/img/flag-id.svg'),
      isoCode: 'ID',
      countryCode: '+62',
      countryName: 'Indonesia'
    },
    {
      urlImage: require('@static/img/flag-th.svg'),
      isoCode: 'TH',
      countryCode: '+66',
      countryName: 'Thailand'
    }
  ]

  const supportedAreaCodesList = getGlobalConfig('supportedAreaCodesList')

  if (supportedAreaCodesList) {
    return supportedAreaCodesList[currentLanguageCode.toLowerCase()].map(item => ({
      urlImage: item.urlImage,
      isoCode: item.countryCode,
      countryCode: item.areaCode,
      countryName: item.countryValue
    }))
  }

  return defaultValues
}

export const getContactByCountryCode = (currentLanguageCode = 'en', countryCode = 'SG') => {
  const areaCodes = getSupportedAreaCodes(currentLanguageCode.toLowerCase())
  const defaultValue = areaCodes.find(it => it.isoCode.toUpperCase() === 'SG')
  const foundRecord = areaCodes.find(it => it.isoCode.toUpperCase() === countryCode)
  return foundRecord || defaultValue
}
